import React, { useEffect } from 'react';
import WebSocketService from './WebSocketService';

const WS_BASE = process.env.REACT_APP_WS_BASE;

export const WebSocketProvider = ({ children }) => {

    useEffect(() => {
        // Establish WebSocket connection when the component is mounted
        //WebSocketService.connect('wss://localhost:8443/ws/ticks');
        WebSocketService.connect(`${WS_BASE}/ws/ticks`);


        // Cleanup WebSocket connection when the component is unmounted
        return () => {
            WebSocketService.close();
        };
    }, []);

    return (
        <React.Fragment>
            {children}
        </React.Fragment>
    );
};
